/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import { getEnv } from '@config';

const { publicPath } = getEnv();

export default function MySelect({
  className,
  options,
  handleMyChange,
  myname,
  id,
  value = '',
  fullWidth,
  label,
  nulloption,
  helperText,
  error,
  ...props
}) {
  const onChange = (e) => {
    e.target = { ...e.target, id: e.target.name };
    handleMyChange(e);
    let el = document.getElementById(id);
    if (el) {
      el = el.tagName === 'INPUT' ? el : el.nextElementSibling;
      const ev = document.createEvent('Event');
      ev.initEvent('change', true, false);
      el.dispatchEvent(ev);
    }
  };

  return (
    <FormControl variant="outlined" fullWidth={fullWidth || true} className={className}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select
        onChange={onChange}
        name={myname}
        value={value}
        error={error}
        id={id}
        // eslint-disable-next-line no-shadow
        IconComponent={(props) => (
          <a
            href
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              position: 'absolute',
              right: '11px',
              pointerEvents: 'none',
            }}
            onClick={() => {}}
          >
            <img
              width="24"
              height="24"
              alt="Icono de seleccionado"
              src={
                props.className.indexOf('MuiSelect-iconOpen') !== -1
                  ? `${publicPath}/select_down.svg`
                  : `${publicPath}/select_up.svg`
              }
            />
          </a>
        )}
        {...props}
      >
        {nulloption ? (
          <MenuItem value="">
            <em>{nulloption}</em>
          </MenuItem>
        ) : null}

        {options.length
          ? options.map((elm, i) => {
              if (elm.value === value) {
                return (
                  <MenuItem
                    key={i}
                    id={`item-${i}`}
                    value={elm.value}
                    selected
                    onClick={elm.onClick}
                  >
                    {elm.text}
                  </MenuItem>
                );
              }
              return (
                <MenuItem key={i} id={`item-${i}`} value={elm.value} onClick={elm.onClick}>
                  {elm.text}
                </MenuItem>
              );
            })
          : ''}
      </Select>
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </FormControl>
  );
}
